// <div data-controller="web--header">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "hamburger", "overlayMenu" ];
  static classes = [ "" ]
  static values = {};

  initialize() {

  }

  toggleMenu(e) {
    this.overlayMenuTarget.classList.toggle("hidden");
  }

  connect() {

  }

  disconnect() {

  }
}